import React, {Component} from 'react';
import {Button, List} from 'semantic-ui-react';
import {connect} from "react-redux";
import {showToast} from "../../actions/ToastAction";
import ComboData from "../../data/ComboData";
import {removeCombo} from "../../actions/ComboActions";

class ComboItem extends Component {
    constructor(props){
        super(props);
        this.state = {
            quantity: props.quantity,
            add_loading: false,
            delete_loading: false,
            remove_loading: false,
        }
    }

    handleAdd = () => {
        let quantity = this.state.quantity+1;
        if(quantity >= 1){
            this.setState({add_loading:true});
            this.update({
                id:this.props.id,
                quantity
            });
        }
    };

    handleDelete = () => {
        let quantity = this.state.quantity-1;
        if(quantity >= 1){
            this.setState({delete_loading:true});
            this.update({
                id:this.props.id,
                quantity
            });
        }
    };

    handleRemove = () => {
        this.remove();
    };

    async update(data) {
        ComboData.update(data, (res) => {
            if (res !== null) {
                this.setState({quantity:data.quantity});
            } else {
                this.props.showToast({
                    show:true,
                    type:'error',
                    message:'Tenemos un problema!'
                });
            }
            this.setState({add_loading:false, delete_loading:false});
        });
    };

    async remove() {
        ComboData.delete(this.props.id, (res) => {
            this.setState({add_loading:false, delete_loading:false});
            if (res === null) {
                this.props.removeCombo(this.props.id);
            } else {
                this.props.showToast({
                    show:true,
                    type:'error',
                    message:'Tenemos un problema!'
                });
            }
        });
    };

    render() {
        return (
            <List.Item>
                <List.Content floated='left'>
                    <Button.Group size='small'>
                        <Button
                            icon='minus'
                            onClick={this.handleDelete}
                            loading={this.state.delete_loading}
                            disabled={this.state.delete_loading}/>
                        <Button content={this.state.quantity} active />
                        <Button
                            icon='plus'
                            onClick={this.handleAdd}
                            loading={this.state.add_loading}
                            disabled={this.state.add_loading}/>
                    </Button.Group>
                </List.Content>
                <List.Content floated='right'>
                    <Button.Group size='small' color='orange'>
                        <Button
                            icon='trash'
                            onClick={this.handleRemove}
                            loading={this.state.remove_loading}
                            disabled={this.state.remove_loading}/>
                    </Button.Group>
                </List.Content>
                <List.Content style={{paddingTop:10}}>{this.props.additional.name}</List.Content>
            </List.Item>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return {
        showToast(data) {
            dispatch(showToast(data));
        },
        removeCombo(id){
            dispatch(removeCombo(id))
        }
    }
}

export default connect(
    null,
    mapDispatchToProps
)(ComboItem);



// WEBPACK FOOTER //
// ./src/components/inventories/ComboItem.js